
export default {

  SET_LAYOUT({ commit }, routeName) {
    let layoutValue = null;
    switch (routeName) {
      case 'dashboard':
      default:
        layoutValue = 'desktop-layout';
        break;
      case 'login':
        layoutValue = 'login-layout';
        break;
      case 'patient':
        layoutValue = 'desktop-layout';
        break;
        case 'forgot-password':
        layoutValue = 'forgot-password';
        break;
        case 'set-password':
        layoutValue = 'update-password-layout';
    }
    commit('setLayout', layoutValue);
  },

  SET_DASHBOARD_TITLE({ commit }, title) {
    commit('setDashboardTitle', title)
  },

  SET_ACTION_TYPE({ commit }, data) {
    commit('SET_ACTION_TYPE', data)
  },

  SET_MENU_DATA({ commit }, data) {
      commit('SET_MENU_DATA', data)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js